import request from '@/config/axios'

export interface ShareholderSettleBuildReqVO {
  startTime: string
  endTime: string
  remark?: string
}

export interface ShareholderSettleBillVO {
  id?: number
  no?: string
  status?: number
  startTime?: string
  endTime?: string
  poolAmount?: number
  bonusAmount?: number
  orderCount?: number
  partnerCount?: number
  confirmTime?: string
  settleTime?: string
  cancelTime?: string
  remark?: string
  createTime?: string
  bonusOverPool?: boolean
  orders?: {
    id?: number
    orderId?: number
    goodsDiscounted?: number
    contributeAmount?: number
    lockStatus?: number
  }[]
  items?: {
    id?: number
    userId?: number
    nickname?: string
    levelId?: number
    levelName?: string
    systemAmount?: number
    adjustAmount?: number
    adjustReason?: string
  }[]
}

export interface ShareholderSettlePreviewVO {
  poolAmount?: number
  bonusAmount?: number
  orderCount?: number
  partnerCount?: number
  overflowCompressed?: boolean
  orders?: any[]
  partners?: any[]
}

export const previewShareholderSettle = async (data: ShareholderSettleBuildReqVO) => {
  return await request.post<ShareholderSettlePreviewVO>({
    url: '/trade/shareholder/settle/preview',
    data
  })
}

export const createShareholderSettle = async (data: ShareholderSettleBuildReqVO) => {
  return await request.post({ url: '/trade/shareholder/settle/create', data })
}

export const adjustShareholderSettle = async (data: {
  billId: number
  userId: number
  adjustAmount: number
  adjustReason?: string
}) => {
  return await request.put({ url: '/trade/shareholder/settle/adjust', data })
}

export const confirmShareholderSettle = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/settle/confirm', params: { id } })
}

export const cancelShareholderSettle = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/settle/cancel', params: { id } })
}

export const settleShareholderSettle = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/settle/settle', params: { id } })
}

export const getShareholderSettle = async (id: number) => {
  return await request.get<ShareholderSettleBillVO>({
    url: '/trade/shareholder/settle/get',
    params: { id }
  })
}

export const getShareholderSettlePage = async (params: any) => {
  return await request.get({ url: '/trade/shareholder/settle/page', params })
}
